export const MAPBOX_API_KEY = "pk.eyJ1IjoibXVzaWNuc3ciLCJhIjoiY2wwdWpkdG85MGxoMjNkb2E3Y251ZXJtNyJ9.BDDSCD_9ZFxI8QrA72QhdA";